import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueToastify from "vue-toastify";
import GLOBAL_MIXIN from './js/globalMixin.js'
Vue.use(VueToastify);

Vue.config.productionTip = false

Vue.mixin(GLOBAL_MIXIN);

new Vue({
  router,
  store,
  i18n,

  render: h => h(App),
}).$mount('#app')
